import React from 'react';

import { TableCard, Box } from 'vindi-ds-components';

import getPropsTagChipStatus from '../utils/get_props_tag_chip_status';
import { tableCard } from '../templates.json';

const TableCardBills = ({ bills }) => {
  const { labels } = tableCard;

  return (
    <Box display='flex' flexDirection='column' gridGap='24px' mb={2}>
      {bills?.map((bill) => {
        const propsTagChipStatus = getPropsTagChipStatus(bill.status);

        return (
          <TableCard.Container key={bill.id}>
            <TableCard.TextWithAction label={labels.name} value={bill.name} />
            <Box display='flex'>
              <TableCard.Text label={labels.id} value={bill.id} />
            </Box>
            <TableCard.Text label={labels.createdAt} value={bill.created_at} />
            <TableCard.Text label={labels.endAt} value={bill.due_at} />
            <Box display='flex'>

              <TableCard.TextWithTagChip
                label={labels.status}
                value={propsTagChipStatus.label}
                kind={propsTagChipStatus.kind}
              />

            </Box>
          </TableCard.Container>
        );
      })}
    </Box>
  );
};

export default TableCardBills;
